import logo_header_desktop from '../../../assets/imgs/logo_header_desktop.svg'
import './style.scss'

function HeaderLogo() {
	return (
		<div className='header-logo-wrap'>
			<a 
				href='/'
				aria-label='link back to home page'
			>
				<img 
					src={logo_header_desktop}
					className="header-logo"
					alt="Skivio logo" 
				/>
			</a>
		</div>
	)
}

export default HeaderLogo